import router, { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { useCmsContent } from '@src/contexts/cms-content-context';
import { useToast } from '@src/contexts/toast-context';
import { removeQueryParam } from '@src/utils/router-urls';

export const useGuestConsentConfirmationErrorToast = () => {
  const { addToast } = useToast();
  const { query } = useRouter();
  // Next.js query will parse param names snake_case to camelCase
  const shouldDisplayConsentConfirmationErrorToast = query['consent-confirmation-error'] === 'true';
  const alreadyDisplayedConsentConfirmationError = useRef(false);
  const content = useCmsContent();

  useEffect(() => {
    if (shouldDisplayConsentConfirmationErrorToast && !alreadyDisplayedConsentConfirmationError.current) {
      addToast({
        type: 'error',
        content: content.guestConsentsConfirmationFailToast,
      });
      removeQueryParam(router, 'consent-confirmation-error');
      alreadyDisplayedConsentConfirmationError.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
